import React, { useEffect, useState } from "react";
import { Modal, Input, Select, Form, Row, Col, Switch, Upload } from "antd";
import { Utils } from "../../../common/Utils";
import { GradePicker } from "../../../components/GradePicker";
import { observer } from "mobx-react";
import { Store } from "../../../store/Store";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import Storage from "@aws-amplify/storage";
import { v4 } from "uuid";

export const OrgDlg = observer(() => {
  const [form] = Form.useForm();
  const { orgEdit } = Store.orgsStore;
  // const [logo, setLogo] = useState<any>();

  useEffect(() => {
    if (orgEdit.model.id) {
      form.setFieldsValue(orgEdit.model);
    }
  }, [orgEdit.model?.id]);

  const save = () => {
    form.validateFields().then((values) => {
      orgEdit.save(values);
    });
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const onState = (state) => {
    orgEdit.model.state = state;
    form.setFieldsValue({ city: undefined });
  };

  const onDivision = (id) => {
    orgEdit.model.divisionId = id;
    form.setFieldsValue({ communityId: undefined });
  };

  const upImg = (key, file, img) => {
    console.log("upImg：", key, file, img);

    Storage.put(key, file, {})
      .then((res) => {
        console.log("upload file res", res);
        // form.setFieldsValue({ logo: `public/${key}` });
        orgEdit.model.logo = `public/${key}`;

        // setLogo({
        //   path: `public/${key}`,
        //   url: `https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/public/${key}`,
        //   imageHeight: img.naturalHeight,
        //   imageWidth: img.naturalWidth,
        //   imageSize: file.size + "",
        // });
      })
      .catch((err) => {
        console.log("Error uploading file: ", err);
      });
  };

  const beforeUpload = (file) => {
    const index = file.name.lastIndexOf(".");
    const ext = file.name.substr(index + 1);
    const key = `${v4()}.${ext.toLowerCase()}`;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img: any = document.createElement("img");
      img.src = reader.result;
      img.onload = () => {
        if (file.size > 1024 * 1024) {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          if (context) {
            let rate = 0.2;
            const fileSizeKB = Math.floor(file.size / 1024);
            console.log("file size：", fileSizeKB, "kb");

            rate = Math.floor((3072 / fileSizeKB) * 10) / 30;
            let targetW = (canvas.width = img.width * rate);
            let targetH = (canvas.height = img.height * rate);
            context.clearRect(0, 0, targetW, targetH);
            context.drawImage(img, 0, 0, targetW, targetH);

            console.log("rate", rate);
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  let imgFile = new File([blob], file.name, { type: file.type });
                  upImg(key, imgFile, img);
                }
              },
              file.type,
              1
            );
          } else {
            upImg(key, file, img);
          }
        } else {
          upImg(key, file, img);
        }
      };
    };

    return false;
  };

  const uploadButton = (
    <div>
      {orgEdit.uploading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <Modal
      title="Organization"
      visible={true}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={orgEdit.saving}
      onCancel={() => orgEdit.close()}
      width={760}
    >
      <Form form={form} {...layout} initialValues={{ ...orgEdit.model }}>
        <Form.Item label="Full Name" name="name" rules={[{ required: true, message: "Please input full name" }]}>
          <Input placeholder="Enter full name" />
        </Form.Item>
        <Form.Item label="Division" name="divisionId" rules={[{ required: true, message: "Please select division" }]}>
          <Select onChange={onDivision}>
            {orgEdit.divisions.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Community"
          name="communityId"
          rules={[{ required: true, message: "Please select community" }]}
        >
          <Select>
            {orgEdit.communities.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="State" name="state" rules={[{ required: true, message: "Please select state" }]}>
          <Select showSearch placeholder="Enter state" optionFilterProp="title" onChange={onState}>
            {orgEdit.states.map((x) => (
              <Select.Option title={`${x.value} (${x.key})`} value={x.key} key={x.key}>
                {x.value} ({x.key})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="City" name="city" rules={[{ required: true, message: "Please select city" }]}>
          <Select showSearch placeholder="Enter city">
            {orgEdit.cityList.map((x) => (
              <Select.Option value={x} key={x}>
                {x}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Street Address" name="street" rules={[{ required: true, message: "Please input address" }]}>
          <Input placeholder="Enter street" />
        </Form.Item>
        <Form.Item label="Zip Code" name="zipCode" rules={[{ required: true, message: "Please input zip code" }]}>
          <Input placeholder="Enter zip code" />
        </Form.Item>
        <Form.Item label="Notes" name="description">
          <Input placeholder="Enter notes" />
        </Form.Item>

        <Row gutter={24}>
          <Col span={16}>
            <Form.Item label="Can Fundraising" name="canFund" valuePropName="checked">
              <Switch />
            </Form.Item>
            <Form.Item label="Is School" name="isSchool" valuePropName="checked">
              <Switch />
            </Form.Item>
            <Form.Item label="Grade Range" name="grades">
              <GradePicker />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Logo">
              <Upload accept="image/*" listType="picture-card" showUploadList={false} beforeUpload={beforeUpload}>
                {orgEdit.model.logo ? (
                  <img
                    src={`https://${process.env.REACT_APP_CLOUDFRONT}.cloudfront.net/${orgEdit.model.logo}`}
                    alt="avatar"
                    style={{ width: "100%" }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
});
